var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9923 2.99902H2.99867C2.44658 2.99902 1.99902 3.44658 1.99902 3.99867V6.9976C1.99902 7.54969 2.44658 7.99725 2.99867 7.99725H20.9923C21.5444 7.99725 21.9919 7.54969 21.9919 6.9976V3.99867C21.9919 3.44658 21.5444 2.99902 20.9923 2.99902Z",
    stroke: "#E17100",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99902 7.99707V18.9932C3.99902 19.5234 4.20966 20.0319 4.5846 20.4069C4.95954 20.7818 5.46807 20.9925 5.99831 20.9925H17.9941C18.5243 20.9925 19.0328 20.7818 19.4078 20.4069C19.7827 20.0319 19.9933 19.5234 19.9933 18.9932V7.99707",
    stroke: "#E17100",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 11.9956H13.9947",
    stroke: "#E17100",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.5c50a9de2c706f794e8fef366345054d.svg";
export { ForwardRef as ReactComponent };